import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import languageRU from './languages/ru.json';
import detector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      "Welcome to React": "Welcome to React and react-i18next"
    }
  },
  ru: {
    translation: languageRU
  }
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(detector)
  .init({
    resources,
    lng: "ru",

    // keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

  export default i18n;
